import { render, staticRenderFns } from "./vendorRelatedAttach.vue?vue&type=template&id=62f13f07"
import script from "./vendorRelatedAttach.vue?vue&type=script&lang=js"
export * from "./vendorRelatedAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f13f07')) {
      api.createRecord('62f13f07', component.options)
    } else {
      api.reload('62f13f07', component.options)
    }
    module.hot.accept("./vendorRelatedAttach.vue?vue&type=template&id=62f13f07", function () {
      api.rerender('62f13f07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorRelatedAttach.vue"
export default component.exports